import { render, staticRenderFns } from "./AvatarsPage.vue?vue&type=template&id=74b6361e&"
import script from "./AvatarsPage.vue?vue&type=script&lang=js&"
export * from "./AvatarsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports